import axios from "axios";

export const state = {
    reportloansbymonths: [],
};

export const getters = {
    reportloansbymonths: state => state.reportloansbymonths,
};

export const mutations = {
    setReportLoansbyMonths(reportloansbymonths, newValue) { state.reportloansbymonths = newValue},
};

export const actions = {
    async fetchReportLoansbyMonths({ commit }) {
        await axios.get('/reportloansbymonths').then(res => {
            commit('setReportLoansbyMonths', res.data.loans)
        })
    },
    async filterReportLoansbyMonths({commit}, {month,year}) { 
        let formData = new FormData();
        formData.append("month", month);
        formData.append("year", year);
        let url = "/filterreportloansbymonths";
        await axios.post(url, formData).then((response) => {
            commit('setReportLoansbyMonths', response.data.loans)
        })
    },
};
